import request from '@/utils/request';
import notifData from '@/mock/notification.data.js';
import { notifyServiceV1 } from '@/config/apiPrefix.config';
import moment from "moment";

// 获取用户购买的服务类型
// export const createOrUpdateNotif = (data) => new Promise((resolve, reject) => { setTimeout(function() { resolve('success') }, 5000) });
export const createOrUpdateNotif = (data) => (
        data.id
        ? request(`${notifyServiceV1}/message/${data.id}`, { method: 'put', body: formatReqData(data) })
        : request(`${notifyServiceV1}/message/`, { method: 'post', body: formatReqData(data) })
    ).then(res => formatResItem(res));

export const getNotifications = (params) => request(`${notifyServiceV1}/message/`, {
    params: {
        type: params.type,
        status: params.status,
        tc: params.term,
        page_num: params.pageNumber,
        page_size: params.pageSize,
    }
}).then(res => ({
    total: res.total,
    notifications: res.data_list.map(item => formatResItem(item))
}));
// export const getNotifications = (params) => (new Promise((resolve, reject) => {
//     let ret = notifData.slice();
//     if (params) {
//         if (params.type)
//             ret = ret.filter(n => n.type === params.type);
//         if (params.status)
//             ret = ret.filter(n => n.status === params.status);
//         if (params.term)
//             ret = ret.filter(n => n.subject.includes(params.term) || n.content.includes(params.term));
//     }
//     resolve(ret);
// })).then(res => res.map(item => formatResItem(item)));

// export const deleteNotification = (id) => new Promise((resolve, reject) => { setTimeout(function() { resolve('success') }, 5000); });
export const deleteNotification = (id) => request(`${notifyServiceV1}/message/${id}`, { method: 'delete' });

function formatResItem(item) {
    return {
        id: item.id,
        timestamp: new Date(item.push_time),
        subject: item.subject,
        content: item.content,
        type: item.type,
        status: item.status,
        sender: item.sender.full_name || item.sender.phone || item.sender.id,
        sender_id: item.sender.id,
        created_at: new Date(item.create_time),
        viaWeb: item.by_platform,
        viaEmail: item.by_email,
        viaPhone: item.by_phone,
        indexNotif: item.index_notify ? new Date(item.index_notify) : null,
        receiversCategory: item.receivers_category,
        receiversUsers: item.receivers_users.map((id, index) => ({ id, phone: item.phones ? item.phones[index] : null })),
    }
}

function formatReqData(data) {
    return {
        subject: data.subject,
        content: data.content,
        type: data.type,
        push_time: moment(data.timestamp).format('YYYY-MM-DD HH:mm:ss'),
        index_notify: data.indexNotif ? moment(data.indexNotif).format('YYYY-MM-DD HH:mm:ss') : null,
        receivers_category: data.receiversCategory,
        receivers_users: data.receiversUsers,
        by_platform: data.viaWeb,
        by_email: data.viaEmail,
        by_phone: data.viaPhone,
    }
}